import statisticsService from 'Services/StatisticsService'

// initial state
const state = {
  intervalOptions: null,
  intervalStatistics: {
    current: null,
    previous: null
  }
}

const getEmptyStatistics = (intervalRange) => {
  return statisticsService.getEmpty(intervalRange)
}

const getStatistics = (context, intervalRange, parameters) => {
  return new Promise((resolve, reject) => {
    statisticsService.getDashboard(context, intervalRange, parameters).then(result => {
      resolve(result)
    }).catch(error => {
      reject(error)
    })
  })
}

const actions = {
  getIntervalOptions: ({ commit, state }, { context, intervalRange, parameters, isPlaceholder = false, isPrepend = false }) => {
    return (isPlaceholder ? getEmptyStatistics(intervalRange) : getStatistics(context, intervalRange, parameters)).then(result => {
      const intervalOptions = isPrepend ? state.intervalOptions : result

      if (isPrepend) {
        intervalOptions.datapoints = [...result.datapoints, ...state.intervalOptions.datapoints]
      }

      commit('setStatisticsProperty', { property: 'intervalOptions', value: intervalOptions })
    })
  },

  getCurrentStatistics: ({ commit, state }, { context, intervalRange, parameters, isPlaceholder = false }) => {
    return (isPlaceholder ? getEmptyStatistics(intervalRange) : getStatistics(context, intervalRange, parameters)).then(result => {
      commit('setStatisticsProperty', { property: 'intervalStatistics', value: { ...state.intervalStatistics, current: result } })

      return result
    })
  },

  getPreviousStatistics: ({ commit, state }, { context, intervalRange, parameters, isPlaceholder = false }) => {
    return (isPlaceholder ? getEmptyStatistics(intervalRange) : getStatistics(context, intervalRange, parameters)).then(result => {
      commit('setStatisticsProperty', { property: 'intervalStatistics', value: { ...state.intervalStatistics, previous: result } })

      return result
    })
  },

  clearStatistics: ({ commit }) => {
    commit('setStatisticsProperty', { property: 'intervalOptions', value: null })
    commit('setStatisticsProperty', { property: 'intervalStatistics', value: { current: null, previous: null } })
  },

  clearPreviousStatistics: ({ commit, state }) => {
    commit('setStatisticsProperty', { property: 'intervalStatistics', value: { ...state.intervalStatistics, previous: null } })
  }
}

// mutations
const mutations = {
  setStatisticsProperty (state, { property, value }) {
    state[property] = value
  }
}

export default {
  state,
  actions,
  mutations
}
